
import moment from 'moment';
import {
  Component, Mixins,
} from 'vue-property-decorator';
import PlanMixin from '@/mixins/PlanMixin.vue';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationPlan extends Mixins(PlanMixin, OperationComponentMixin) {
}
